import { ItemIcon, PlainTooltip, Type } from "@similarweb/ui-components";

import { generateAutomationName } from "../../../../helpers/generateAutomationName";

import { MainCompetitorWrapper, WebsiteName } from "./styles";
import type { MainCompetitorSchema } from "./type";

export const MainCompetitor = ({
    name,
    image,
    onClick,
    disabled,
    isActive = true,
    isTooltipEnabled = false,
    tooltipContent = "",
}: MainCompetitorSchema) => {
    const onClickWrapper = () => !disabled && onClick();
    const enabled = isTooltipEnabled && !!tooltipContent;

    return (
        <PlainTooltip
            enabled={enabled}
            tooltipContent={tooltipContent}
        >
            <span className="main-competitor-tooltip">
                <MainCompetitorWrapper
                    data-automation={generateAutomationName("settings", ["competitors", "main", "wrapper"])}
                    onClick={onClickWrapper}
                    disabled={disabled}
                    isActive={isActive}
                >
                    <ItemIcon
                        iconSrc={image}
                        iconType={Type.Website}
                    />
                    <WebsiteName>{name}</WebsiteName>
                </MainCompetitorWrapper>
            </span>
        </PlainTooltip>
    );
};
